import { useCallback, useState } from "react";

// The "Start review" programme-picker dialog (PCRSAddProgrammeDialog).
//
// openProgrammePicker optionally takes a review type to preselect, so the
// Programme availability cards can open the dialog already on the programme the
// user clicked. It is also passed directly as an onClick handler in places,
// which would hand it a click event — hence the string guard.
export const useProgrammePicker = () => {
  const [isPcrsAddProgrammeDialogOpen, setIsPcrsAddProgrammeDialogOpen] =
    useState(false);
  const [preselectedReviewType, setPreselectedReviewType] = useState("");

  const openProgrammePicker = useCallback((reviewType) => {
    setPreselectedReviewType(typeof reviewType === "string" ? reviewType : "");
    setIsPcrsAddProgrammeDialogOpen(true);
  }, []);

  const closeProgrammePicker = useCallback(() => {
    setIsPcrsAddProgrammeDialogOpen(false);
    setPreselectedReviewType("");
  }, []);

  return {
    isPcrsAddProgrammeDialogOpen,
    preselectedReviewType,
    openProgrammePicker,
    closeProgrammePicker,
  };
};
